import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { api } from "@/lib/api";
import { T } from "@/constants/testIds";

const TYPE_TO_URL = {
  article: (slug) => `/articles/${slug}`,
  bible_study: (slug) => `/bible-studies/${slug}`,
  doctrine: (slug) => `/what-we-believe/${slug}`,
  question: (slug) => `/questions/${slug}`,
  kids_story: (slug) => `/kids/${slug}`,
  devotional: () => `/devotionals`,
};

const TYPE_LABEL = {
  article: "Article",
  bible_study: "Bible Study",
  doctrine: "Doctrine",
  question: "Question",
  kids_story: "Kids' Story",
  devotional: "Devotional",
};

export default function Search() {
  const [sp, setSp] = useSearchParams();
  const initial = sp.get("q") || "";
  const [q, setQ] = useState(initial);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!initial) return;
    setLoading(true);
    api.get(`/search?q=${encodeURIComponent(initial)}`).then((r) => setResults(r.data.results || [])).catch(() => setResults([])).finally(() => setLoading(false));
  }, [initial]);

  const submit = (e) => {
    e.preventDefault();
    setSp({ q });
  };

  return (
    <>
      <PageHero eyebrow="Search" title="Find what you are looking for.">
        <form onSubmit={submit} className="mt-4 flex gap-2 max-w-xl">
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search articles, Bible studies, questions…"
            className="flex-1 border border-border bg-paper px-4 py-3 text-sm focus:outline-none focus:border-ink"
          />
          <button className="btn-primary" type="submit">Search</button>
        </form>
      </PageHero>
      <section className="py-16">
        <div className="container-editorial">
          {loading && <p className="text-ink-muted">Searching…</p>}
          {!loading && initial && results.length === 0 && (
            <div>
              <p className="body-copy text-ink-muted">No results for “{initial}”. Try one of these:</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {["eternal life", "who is Jesus", "gospel", "trinity", "prayer"].map((s) => (
                  <Link key={s} to={`/search?q=${encodeURIComponent(s)}`} className="px-3 py-1.5 border border-border text-sm hover:border-ink">
                    {s}
                  </Link>
                ))}
              </div>
            </div>
          )}
          <div className="space-y-6">
            {results.map((r, i) => (
              <Link
                key={i}
                to={TYPE_TO_URL[r.type] ? TYPE_TO_URL[r.type](r.slug) : "#"}
                data-testid={T.searchResultItem(i)}
                className="block border-b border-border pb-6 hover:bg-subtle -mx-4 px-4"
              >
                <span className="eyebrow text-forest">{TYPE_LABEL[r.type] || r.type}</span>
                <h3 className="font-serif text-2xl mt-2 text-ink" style={{ fontWeight: 500 }}>{r.title}</h3>
                <p className="body-copy mt-2 text-ink-muted">{r.summary}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
